import { defineLocaleTargets } from './utilities';

export const CartLocales = defineLocaleTargets('cart', <const>{
	adjustments: '',
	amountDue: '',
	confirmationOfRemoval: '',
	confirmRemoveAllItemsOfProduct: '',
	empty: '',
	errorLoading: '',
	errorLoadingDesc: '',
	fees: '',
	item: '',
	items: '',
	orderSummary: '',
	shipping: '',
	shoppingCart: '',
	subtotal: '',
	tax: '',
	total: '',
	totalSavings: '',
	clearCart: '',
});
